import { render, staticRenderFns } from "./SecurityPolicyContent.vue?vue&type=template&id=d970ba08&scoped=true"
import script from "./SecurityPolicyContent.vue?vue&type=script&lang=ts"
export * from "./SecurityPolicyContent.vue?vue&type=script&lang=ts"
import style0 from "./SecurityPolicyContent.vue?vue&type=style&index=0&id=d970ba08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d970ba08",
  null
  
)

export default component.exports